module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Treiber"},"en":{"title":"Driver"}}')
  delete Component.options._Ctor
}
